<mat-nav-list
  class="side-nav-menu-list"
  [ngClass]="{
    'selected-list': isExpanded(),
    'default-list text-hover': !isExpanded(),
    dark: isDark
  }"
>
  <mat-expansion-panel
    (opened)="isExpanded.set(true)"
    (closed)="isExpanded.set(false)"
    class="side-nav-panel"
  >
    <mat-expansion-panel-header
      [ngClass]="!isExpanded ? 'expansion-panel' : ''"
      class="side-nav-header"
    >
      <mat-panel-header
        class="menu-sections-text section-text"
        [ngClass]="{ dark: isDark }"
      >
        {{ navTitle }}
      </mat-panel-header>
    </mat-expansion-panel-header>
    @if (isExpanded()) {
      @for (sections of dropdownData; track sections) {
        <mat-list class="sidenav-section">
          @for (subsection of sections.links; track subsection) {
            <mat-list-item class="inner-section">
              <a
                [routerLink]="subsection.route"
                [queryParams]="subsection?.queryParams"
                class="inner-section section-text"
                [ngClass]="{ dark: isDark }"
              >
                {{ subsection.name }}
              </a>
            </mat-list-item>
          }
        </mat-list>
      }
    }
  </mat-expansion-panel>
</mat-nav-list>
